import ax from "./ax";

// 业绩详情(汇总/个人/代理)(日/月)
export function GetReward(data = {}) {
  return ax({
    url: "/app/Reward/" + PUBLIC_INTERFACE.getReward,
    method: "post",
    data
  });
}

// 业绩详情(汇总/个人/代理)(日/月)
export function GetRewardBuschannel(data = {}) {
  return ax({
    url: "/app/Reward/" + PUBLIC_INTERFACE.getRewardBuschannel,
    method: "post",
    data
  });
}

// 汇总业绩/个人业绩/代理业绩
export function GetTradeCount(data = {}) {
  return ax({
    url: "/app/Reward/" + PUBLIC_INTERFACE.getTradeCount,
    method: "post",
    data
  });
}

// 进阶指标
export function AdvancedTarget(data = {}) {
  return ax({
    url: "/app/Reward/" + PUBLIC_INTERFACE.advancedTarget,
    method: "post",
    data
  });
}

// 日/月收益
export function GetProfit(data = {}) {
  return ax({
    url: "/app/Reward/GetProfit",
    method: "post",
    data
  });
}

// 日/月收益
export function GetUserTaskExpired(data = {}) {
  return ax({
    url: "/app/Reward/GetUserTaskExpired",
    method: "post",
    data
  });
}

// 日/月收益
export function GetUserTaskExpiredList(data = {}) {
  return ax({
    url: "/app/Reward/GetUserTaskExpiredList",
    method: "post",
    data
  });
}